import { render, staticRenderFns } from "./Wp_access_count.vue?vue&type=template&id=547becea&scoped=true&"
import script from "./Wp_access_count.vue?vue&type=script&lang=js&"
export * from "./Wp_access_count.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547becea",
  null
  
)

export default component.exports